import { enClientPortalAssetDeviationAnalysis } from './AssetDetails/AssetDeviationAnalysis/AssetDeviationAnalysis'
import { enClientPortalAssetKeyValues } from './AssetDetails/AssetKeyValues/AssetKeyValues'
import { enClientPortalAssetPageLayout } from './AssetDetails/AssetPageLayout/AssetPageLayout'
import { enClientPortalAssetValuationList } from './AssetDetails/AssetValuationList/AssetValuationList'
import { enClientPortalValuationCommon } from './AssetDetails/Valuation'
import { enClientPortalValueCheckPages } from './AssetDetails/ValueCheck'

export const enClientPortalAssetDetailsCommon = {
    assetDetails: {
        assetPageLayout: enClientPortalAssetPageLayout,
        assetValuationList: enClientPortalAssetValuationList,
        assetKeyValues: enClientPortalAssetKeyValues,
        assetDeviationAnalysis: enClientPortalAssetDeviationAnalysis,
        valueCheck: enClientPortalValueCheckPages,
        valuation: enClientPortalValuationCommon,
    },
}
